module.exports = __webpack_public_path__ + "de02af809ee30dc513abe9a1533b91bf.png";


//////////////////
// WEBPACK FOOTER
// ./web/images/icons/envelope.png
// module id = 615
// module chunks = 0